export function buildTag({ tag, label }) {
  return `<span class="tag ${tag} is-capitalized" style="width:100%">${label}</span>`;
}



// WEBPACK FOOTER //
// ./src/components/climan/helpers/index.js